<template>
  <div
    class="dataTableJoinedRow"
  >
    <div>
      {{ joined }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataTableJoinedRow',
  props: {
    value: {
      type: String,
      default() {
        return '';
      },
    },
    options: {
      type: Object,
      default() {
        return {
          valueList: [],
          separator: '-',
        };
      },
    },
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    joined() {
      if (!this.options.valueList) {
        return '';
      }
      return this.options.valueList.map(value => this.getPropByString(this.row, value))
        .join(this.options.separator);
    },
  },
  methods: {
    getPropByString(obj, desc) {
      return desc.split('.').reduce((a, b) => a[b] || '', obj);
    },
  },
};
</script>
